// For something clickable that can't be a real <button> (it already holds a
// button of its own, or its layout depends on block-level children): with
// role="button" and tabIndex={0}, this lets Enter or Space press it, as they
// would a button. Only when the element itself has focus, so a key pressed on
// a button inside it isn't handled twice. preventDefault stops Space from also
// scrolling the page.
export function pressOnEnterOrSpace(handler) {
  return (e) => {
    if ((e.key === "Enter" || e.key === " ") && e.target === e.currentTarget) {
      e.preventDefault();
      handler(e);
    }
  };
}
